import React from 'react';
import { Button } from 'antd';
import ProductDetails from '../productDetails';
import ProductDescription from './ProductDescription';
import ProductInfoHeader from './ProductInfoHeader';
import ProductPurchaseSelectors from './ProductPurchaseSelectors';
import ProductTypeRow from './ProductTypeRow';
import ProductVariantSummary from './ProductVariantSummary';
import useInfoForProduct from './useInfoForProduct';
import './infoForProductById.scss';

const InfoForProductById: React.FC = () => {
  const {
    curProduct,
    selectedMaterial,
    selectedSize,
    price,
    materialDataLoading,
    variantSummary,
    addToCartLabel,
    addingToCart,
    handleAddToCart,
  } = useInfoForProduct();

  if (!curProduct) {
    return <div>Product not found</div>;
  }

  return (
    <div className="info-container">
      <ProductInfoHeader productId={curProduct.id} title={curProduct.title} />
      <ProductDescription description={curProduct.description} />
      <ProductTypeRow typeName={curProduct.productType?.name} />
      <ProductPurchaseSelectors productId={curProduct.id} selectedSize={selectedSize} />
      <ProductVariantSummary
        selectedVariantLabel={variantSummary.selectedVariantLabel}
        price={price}
        loading={materialDataLoading}
      />
      <Button
        type="primary"
        block
        onClick={handleAddToCart}
        loading={addingToCart}
        disabled={!variantSummary.canAddToCart}
      >
        {addToCartLabel}
      </Button>
      <ProductDetails value={selectedMaterial} />
    </div>
  );
};

export default InfoForProductById;
